import React from 'react';
import { Modal } from 'react-bootstrap';
import styled, { useTheme } from 'styled-components';
import Portlet from '../../app/components/portlet/Portlet';
import PortletBody from '../../app/components/portlet/PortletBody';
import { StyledLabel } from '../../assets/styledComponents/Global';
import ModalBgIcon from '../../app/components/svgIcons/ModalBgIcon';
import ModalBgIcon2 from '../../app/components/svgIcons/ModalBgIcon2';


const DescriptionModal = ({
    show,
    onHide,
    data,
    index
}) => {
    const theme = useTheme()

    return (

        <Modal show={show} backdrop="static" centered onHide={onHide} size={'lg'}>

            <Modal.Header closeButton className="d-flex border-bottom-0  pb-1 align-items-baseline bg-danger" >

            </Modal.Header>
            <Modal.Body className="d-flex flex-column rounded bg-white position-relative">

                <Portlet>
                    <PortletBody>
                        <div className='d-flex flex-column justify-content-center align-items-center'>

                            <StyledLabel size='24px' color={theme?.darktext} className="flex-grow-1 px-0 cursor-pointer flex-center pt-md-1 pb-md-0 font-fredoka fw-normal">
                                Question #{index + 1} Description
                            </StyledLabel>
                            
                            <div>
                                <StyledLabel size={'14px'} weight={'400'} className="text-muted pb-md-3" >
                                    {data?.text} </StyledLabel>
                            </div>
                        </div>
                        <div className="row px-4">
                            <div className={'d-flex flex-column col-md-12 bg-body my-3 p-3 rounded'}>
                                <div className='d-flex flex-column gap-2'>

                                    <StyledLabel size={'14px'} weight={'700'} color={theme?.darktext} className=" pb-md-1" >
                                        Description </StyledLabel>
                                </div>

                                <StyledLabel size='14px' weight='400' color={theme?.darktext}>
                                    {data?.description}
                                </StyledLabel>


                            </div>
                        </div>


                    </PortletBody>
                </Portlet>


                <div className="d-flex justify-content-center ">
                    <div className="d-flex gap-3">


                    </div>
                </div>

                <StyledIcon>
                    <ModalBgIcon />
                </StyledIcon>


                <StyledIcon2>
                    <ModalBgIcon2 />
                </StyledIcon2>
            </Modal.Body>

        </Modal>

    );
}



export default DescriptionModal;


const StyledIcon = styled.div`
position:absolute;
bottom:50px;
right:100px;
`

const StyledIcon2 = styled.div`
position:absolute;
top:10px;
left:200px;
`

